<template>
    <div class="modal-overlay" @click="$emit('close')">
        <div class="modal" ref="myBtn" @click="$emit('close')">
            <p class="cssMessage">{{message}}</p>
            <div class="d-flex gap-3">
                <button class="confirm-btn" @click="confirmHandler">{{confirmBtn}}</button>
                <button class="cancle-btn" @click="cancleHandler">{{cancleBtn}}</button>
            </div>

        </div>
    </div>
</template>

<script>
    // import {onMounted} from "vue";
    // import mitt from 'mitt';
    // const emitter = mitt();
    export default {
        name:'confirmation-component',
        props: ['cancleBtn', 'confirmBtn', 'message'],
        data(){
            return {
                state: false
            }
        },
        methods:{
            confirmHandler(){
                // this.state = true;
                // this.$refs?.myBtn?.click();
            this.$emit('close-modal', true)
            },
            cancleHandler(){
                // this.state = false;
                // this.$refs?.myBtn?.click()

                this.$emit('close-modal', false)
            }
        }

    }
</script>

<style scoped>

    .cssMessage{
        color: var(--text-color-in-Confirm-immed);
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000;
        z-index: 100;
    }

    .modal {
        text-align: center;
        display: flex !important;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        position: unset !important;
        background-color: var(--background-color-input-create);
        height: 200px;
        border-radius: 20px;
        margin: auto;
        width: 40%;
    }


    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        font-size: 22px;
        margin: 30px 0;
        color: #FFF;
    }

    button {
        width: 150px;
        height: 50px;
        color: white;
        font-size: 18px;
        border-radius: 8px;
        font-weight: 600;
    }

    .confirm-btn{
        background-color: var(--btn-bg-color);
        border: 1px solid transparent;
    }
    .cancle-btn{
        background-color: transparent;
        color: var(--text-color-in-confirmation-modal);
        border: 1px solid var(--text-border-color-in-confirmation-modal);
    }
</style>